module.exports = "fragment ImageFragment on Image {\n  id\n  url\n  smallThumb: url(width: 135, height: 135, fitIn: false)\n  width\n  height\n}\n"